// Newsletter issues config
// To add a new issue every 15 days, just append a new entry to this array.
// Place the PDF in /public/newsletters/ and the cover thumbnail in /public/assets/images/newsletters/

export const newsletterIssues = [
  {
    id: "impact-edition-6",
    title: "ImpAct — Edition 6",
    date: "September 16–30, 2026",
    description: "Top education stories, GSLC spotlight, and what's coming next.",
    cover: "/assets/images/newsletters/impact-edition-6-cover.jpg",
    file: "/newsletters/impact-edition-6.pdf",
  },
  {
    id: "impact-edition-5",
    title: "ImpAct — Edition 5",
    date: "September 1–15, 2026",
    description: "Top education stories, GSLC spotlight, and what's coming next.",
    cover: "/assets/images/newsletters/impact-edition-5-cover.jpg",
    file: "/newsletters/impact-edition-5.pdf",
  },
  {
    id: "impact-edition-4",
    title: "ImpAct — Edition 4",
    date: "August 16–31, 2026",
    description: "Top education stories, GSLC spotlight, and what's coming next.",
    cover: "/assets/images/newsletters/impact-edition-4-cover.jpg",
    file: "/newsletters/impact-edition-4.pdf",
  },
  {
    id: "impact-edition-3",
    title: "ImpAct — Edition 3",
    date: "August 1–15, 2026",
    description: "Top education stories, GSLC spotlight, and what's coming next.",
    cover: "/assets/images/newsletters/impact-edition-3-cover.jpg",
    file: "/newsletters/impact-edition-3.pdf",
  },
  {
    id: "impact-edition-2",
    title: "ImpAct — Edition 2",
    date: "July 16–31, 2026",
    description: "Top education stories, GSLC spotlight, and what's coming next.",
    cover: "/assets/images/newsletters/impact-edition-2-cover.jpg",
    file: "/newsletters/impact-edition-2.pdf",
  },
  {
    id: "impact-july-2026-fortnight-1",
    title: "ImpAct — July 2026 (1st Fortnight)",
    date: "July 1–15, 2026",
    description: "Top education stories, GSLC spotlight, and what's coming next.",
    cover: "/assets/images/newsletters/impact-july-2026-fortnight-1-cover.jpg",
    file: "/newsletters/impact-july-2026-fortnight-1.pdf",
  },
  {
    id: "impact-june-2026",
    title: "ImpAct — June 2026",
    date: "June 2026",
    description: "Top education stories, GSLC spotlight, and what's coming next.",
    cover: "/assets/images/newsletters/impact-june-2026-cover.jpg",
    file: "/newsletters/impact-june-2026.pdf",
  },
];
